export default "__VITE_ASSET__e5145610__"